import React, { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Technology", href: "#technology" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("Home");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`shc-navbar navbar navbar-expand-lg navbar-dark w-100 ${scrolled ? "is-scrolled" : ""
        }`}
    >
      <div className="container">

        {/* Logo - Left */}
        <a href="#home" className="shc-logo">
          <img
            src="../../images/logo.png"
            alt="Star Home Cinemas"
          />
        </a>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#shcNavCollapse"
          aria-controls="shcNavCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation - Right */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="shcNavCollapse"
        >
          <ul className="navbar-nav mb-3 mb-lg-0">
            {NAV_LINKS.map((link) => (
              <li className="nav-item" key={link.label}>
                <a
                  href={link.href}
                  className={`nav-link shc-nav-link ${active === link.label ? "active" : ""
                    }`}
                  onClick={() => setActive(link.label)}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <a
            href="#contact"
            className="shc-btn shc-btn-outline-light d-none d-lg-inline-block ms-4"
          >
            Enquire Now
          </a>
        </div>
      </div>
    </nav>
  );
}
